import { render, staticRenderFns } from "./tMobile.vue?vue&type=template&id=edf02470&scoped=true&"
import script from "./tMobile.vue?vue&type=script&lang=ts&"
export * from "./tMobile.vue?vue&type=script&lang=ts&"
import style0 from "./tMobile.vue?vue&type=style&index=0&id=edf02470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf02470",
  null
  
)

export default component.exports